import { render } from "./BancoList.vue?vue&type=template&id=ca675594&scoped=true"
import script from "./BancoList.vue?vue&type=script&lang=js"
export * from "./BancoList.vue?vue&type=script&lang=js"

import "./BancoList.vue?vue&type=style&index=0&id=ca675594&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_restaurante\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca675594"]])

export default __exports__